// extracted by mini-css-extract-plugin
module.exports = {"products":"Gy-z","misad":"Hy-z","colorSwatchWrapper":"Iy-z","oosMessaging":"Jy-z"};